import {
  ChangeDetectionStrategy,
  Component, computed,
  inject,
  input,
  OnInit, output,
  signal
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { languages } from './app-header.consts';
import { AuthenticationService } from '@frontend-mono/shared-auth';
import { IconRegistryService } from '../../services/icon-registry.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lib-app-header',
  imports: [
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    NgOptimizedImage
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHeaderComponent implements OnInit {
  public readonly email = input<string>();
  public readonly initialLanguage = input('en');
  public readonly appName = input('');
  public readonly showMenu = input(true);
  public readonly menuClick = output<void>();
  public readonly logoClick = output<void>();
  public readonly languageChange = output<string>();
  public readonly languages = languages;

  public readonly selectedLanguageId = signal<string>('');

  public readonly selectedLanguage = computed(() => {
    const langId = this.selectedLanguageId();
    if (langId) {
      return this.languages.find(lang => lang.code === langId)!;
    }

    const initial = this.initialLanguage();
    const foundLang = this.languages.find(lang => lang.code === initial);
    return foundLang || this.languages[0];
  });

  private readonly iconRegistry = inject(IconRegistryService);
  private readonly authService = inject(AuthenticationService);

  public ngOnInit(): void {
    this.iconRegistry.registerIcons(languages.map(({icon}) => icon));
    const initial = this.initialLanguage();
    const isValidLang = this.languages.some(lang => lang.code === initial);
    this.selectedLanguageId.set(isValidLang ? initial : this.languages[0].code);
  }

  public onLanguageChange(languageCode: string): void {
    this.selectedLanguageId.set(languageCode);
    this.languageChange.emit(languageCode);
  }

  public logout(): void {
    this.authService.logout();
  }
}
